import { IonCol, IonGrid, IonRow } from '@ionic/react';

import styles from './CalibrationFailed.module.css';

import { Icon } from '../Icon';

interface CalibrationFailedProps {
  title: string;
  description: string;
}

export const CalibrationFailed = ({ title, description }: CalibrationFailedProps) => {
  return (
    <IonGrid className={styles.container}>
      <IonRow className='ion-align-items-center'>
        <IonCol className='ion-align-items-center ion-text-center'>
          <Icon className={styles.icon} name='error' size={16} />
          <h2 className={styles.title}>{title}</h2>
          <p className={styles.description}>{description}</p>
        </IonCol>
      </IonRow>
    </IonGrid>
  );
};
